import { host } from "../../config/Config";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./style/style-mob.css";
import img from "../../resources/logo.webp";

export const UserLogin = () => {
    const [phone, setPhone] = useState("");
    const [password, setPassword] = useState("");
    const [phoneError, setPhoneError] = useState("");
    const [error, setError] = useState("");
    const [kredencijali, setKredencijali] = useState("");
    const navigate = useNavigate();

    // Function to check if user is already authenticated
    const checkUser = async () => {
        // Check for education user token first
        const userType = localStorage.getItem("zajednica-user-type");
        const zajednicaToken = localStorage.getItem("zajednica-token");

        if (zajednicaToken && userType === "education") {
            navigate("/profile");
            return;
        }

        // Check for admin token
        const token = localStorage.getItem("jwt-vlada");
        if (!token) return; // No token, so no need to check

        try {
            const response = await fetch(`${host}/api/v1/auth/check-user`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            const isAuthenticated = await response.json();
            if (response.ok && isAuthenticated) {
                navigate("/admin"); // Redirect if authenticated
            }
        } catch (error) {
            navigate("/");
        }
    };

    useEffect(() => {
        checkUser();
    }, []);

    const handlePocetna = () => {
        navigate("/");
    };

    const handleLogin = async () => {
        if (phone.trim() === "" || password.trim() === "") {
            if (password.trim() === "") {
                setError("Unesi lozinku");
            }
            if (phone.trim() === "") {
                setPhoneError("Telefon (06* ******)");
            }
            return;
        }

        try {
            const response = await fetch(`${host}/api/v1/auth/login`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    username: phone,
                    password: password,
                }),
            });

            const result = await response.json();
            console.log("Login response:", result);
            console.log("isEducationUser value:", result.isEducationUser);
            if (response.ok && result.token) {
                localStorage.setItem("zajednica-token", result.token);
                localStorage.setItem("zajednica-phone", phone);
                localStorage.setItem("zajednica-name", result.name);
                localStorage.setItem(
                    "zajednica-user-type",
                    result.isEducationUser === true ? "education" : "regular"
                );
                localStorage.setItem(
                    "zajednica-is-education-user",
                    result.isEducationUser === true ? "true" : "false"
                );
                if (result.email) {
                    localStorage.setItem("zajednica-email", result.email);
                }
                setError("");
                navigate("/profile");
            } else {
                phone = "";
                password = "";
                setKredencijali("Neispravni kredencijali");
            }
        } catch (error) {
            setPhone("");
            setPassword("");
            setKredencijali("Neispravni kredencijali");
        }
    };

    return (
        <div className='barber-zajednica-admin-page'>
            <div className='barber-zajednica-admin-background'></div>
            <h1>Prijava</h1>
            <input
                type='number'
                placeholder={phoneError ? phoneError : "Telefon (06* ******)"}
                className={
                    phoneError
                        ? "barber-zajednica-input-password-invalid"
                        : "barber-zajednica-input-password"
                }
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
            />

            <input
                style={{ marginTop: "40px" }}
                type='password'
                placeholder={error ? error : "Unesi lozinku"}
                className={
                    error
                        ? "barber-zajednica-input-password-invalid"
                        : "barber-zajednica-input-password"
                }
                value={password}
                onChange={(e) => setPassword(e.target.value)}
            />
            {kredencijali && (
                <p
                    style={{
                        color: "#961515",
                        marginTop: "20px",
                        marginBottom: "-30px",
                    }}
                >
                    {kredencijali}
                </p>
            )}
            <button
                className='barber-zajednica-login-button-user'
                onClick={handleLogin}
            >
                Prijavi se
            </button>
            <button
                className='barber-zajednica-login-button-user'
                onClick={handlePocetna}
                style={{ marginTop: "30px", marginBottom: "40px" }}
            >
                Početna strana
            </button>
            <div className='barber-zajednica-admin-logo'>
                <img src={img} alt='Logo' />
            </div>
        </div>
    );
};
